import { Checkbox, Input, Select, Textarea } from '@sixfold/common-ui';
import React from 'react';

import { handeInputChangeEvent } from '../../lib/form';
import { ConnectionParameterFieldType } from '../../lib/graphql';

interface Props {
  fieldType: ConnectionParameterFieldType;
  label: string;
  settingsValue: string;
  fieldName: string;
  disabled: boolean;
  defaultChecked: boolean;
  enumFieldValues: { value: string; display_name: string | null; is_default: boolean }[];
  onChange: (e: handeInputChangeEvent) => void;
  hasError: boolean;
}

export const IntegrationInputField: React.FunctionComponent<Props> = ({
  fieldType,
  label,
  settingsValue,
  fieldName,
  disabled,
  defaultChecked,
  enumFieldValues,
  onChange,
  hasError,
}) => {
  switch (fieldType) {
    case ConnectionParameterFieldType.NUMBER: {
      return (
        <Input
          label={label}
          type="number"
          value={settingsValue}
          name={fieldName}
          disabled={disabled}
          invalid={hasError}
          onChange={({ event }) => onChange(event)}
        />
      );
    }
    case ConnectionParameterFieldType.BOOLEAN: {
      return (
        <Checkbox
          label={label}
          name={fieldName}
          checked={defaultChecked}
          disabled={disabled}
          invalid={hasError}
          onChange={({ event }) => onChange(event)}
        />
      );
    }

    case ConnectionParameterFieldType.TEXT:
    case ConnectionParameterFieldType.URL:
    case ConnectionParameterFieldType.JSON: {
      return (
        <Textarea
          label={label}
          value={settingsValue.toString()}
          name={fieldName}
          disabled={disabled}
          invalid={hasError}
          rows={1}
          onChange={({ event }) => onChange(event)}
        />
      );
    }
    case ConnectionParameterFieldType.ENUM: {
      const options = (enumFieldValues ?? []).map((v) => ({
        value: v.value,
        label: v.display_name ?? v.value,
      }));

      return (
        <Select
          label={label}
          labelPosition="block"
          options={options}
          value={settingsValue.toString()}
          disabled={disabled}
          isInvalid={hasError}
          onChange={(option) => {
            if (option !== null) {
              onChange({ value: option.value, name: fieldName });
            }
          }}
        />
      );
    }
  }
};
